var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpikHelpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d9cd3;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.5,26h22.5c.8,0,1.5-.7,1.5-1.5V2.5c0-.8-.7-1.5-1.5-1.5H7.5c-2.8,0-5,2.2-5,5v22c0,2.8,2.2,5,5,5h22.5c.8,0,1.5-.7,1.5-1.5s-.7-1.5-1.5-1.5H7.5c-1.1,0-2-.9-2-2s.9-2,2-2ZM18.1,21.1c-.3.3-.7.4-1.1.4s-.8-.2-1.1-.4c-.3-.3-.4-.7-.4-1.1s.2-.8.4-1.1c.6-.6,1.6-.6,2.1,0s.4.7.4,1.1-.2.8-.4,1.1ZM14.1,6.6c1-.8,2.4-1.2,3.7-1,1.8.3,3.3,1.8,3.6,3.6.3,1.9-.6,3.8-2.3,4.7-.4.2-.7.7-.7,1.3v.2c0,.8-.7,1.5-1.5,1.5s-1.5-.7-1.5-1.5v-.2c0-1.7.9-3.2,2.2-3.9.4-.2.9-.8.8-1.6-.1-.6-.6-1.1-1.2-1.2-.5,0-.9,0-1.2.3-.3.3-.5.7-.5,1.2,0,.8-.7,1.5-1.5,1.5s-1.5-.7-1.5-1.5c0-1.3.6-2.6,1.6-3.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpikHelpIcon);
export default __webpack_public_path__ + "static/media/Epik_Help_icon.5e860ec66192a8996329176dafc20ab0.svg";
export { ForwardRef as ReactComponent };